import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => ({
    user: JSON.parse(localStorage.getItem('user')) || null,
    token: localStorage.getItem('token') || null
  }),
  actions: {
    setAuth(token, user) {
      this.token = token
      this.user = user
      localStorage.setItem('token', token)
      localStorage.setItem('user', JSON.stringify(user))
    },
    logout() {
      this.token = null
      this.user = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    },
    loadUser() {
      this.token = localStorage.getItem('token')
      const stored = localStorage.getItem('user')
      this.user = stored ? JSON.parse(stored) : null
    }
  },
  getters: {
    isLoggedIn: state => !!state.token
  }
})
